import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { Button } from 'antd';

import SearchUser from '../../SearchUser';
import styles from './styles.module.scss';

export const FormRender = ({
  location: { pathname }, user, newUser, save, saving, unselectUser, selectUser,
}) => (
  <form className={styles.form}>
    {user
      ? (
        <div>
          <p>La zone est attribuée à:</p>
          <p>
            <NavLink to={`${pathname.replace(/\/zone\/.*$/, '')}/${user.id}`}>
              {user.email}
            </NavLink>
          </p>
          <p className={styles.form__button}>
            <Button
              onClick={unselectUser}
            >
            Choisir un autre agent
            </Button>
          </p>
        </div>
      )
      : (
        <div>
        Choisir un agent :
          <SearchUser
            onSelect={selectUser}
            inGroups={['N1']}
          />
          {newUser && (
            <div className={styles.form__button}>
              <Button
                type="primary"
                onClick={save}
                disabled={saving}
              >
                Attribuer l'agent
              </Button>
            </div>
          )}
        </div>
      )
    }
  </form>
);

export default withRouter(FormRender);



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/ZoneEdit/Form/render.js